import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  active: localStorage.getItem('activeUnit') || 'car_sales',
};

const systemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    setBusinessUnit: (state, action) => {
      state.active = action.payload;
      localStorage.setItem('activeUnit', action.payload);
    },
  },
});

export const { setBusinessUnit } = systemSlice.actions;
export default systemSlice.reducer;
